export default "__VITE_ASSET__BoYi9DFX__"